<template>
  <div class="user-idle-block">
    <h3 :class="{ 'mt-3': margin }">Recently Idle</h3>
    <b-list-group>
      <b-list-group-item v-for="(i) in recentIdles" :key="i.id"
        class="d-flex justify-content-start align-items-center p-1 idle">
        <b-img rounded="circle" class="profile-img" :src="`/api/user/${i.author.id}/photo?token=${token}`" />
        <div class="w-100 mt-1">
          <div class="mb-1">
            <b-row>
              <b-col>
                {{ i.author.displayName }}
              </b-col>
            </b-row>
          </div>
          <div class="idle-dates">
            <div v-for="d in i.days" :key="`${i.author.id}-${d.date.format()}`"
              :class="['day-wrapper', { 'today': d.isToday }]">
              <span :class="['day-bubble', { 'idle': d.isIdle, 'weekend': d.isWeekend, 'today': d.isToday }]">
                {{ d.idleHours > 0 ? d.idleHours : d.n }}
              </span>
            </div>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import Services from '@/services';

export default {
  mounted() {
    this.init();
  },
  props: {
    margin: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      idle: [],
    };
  },
  components: {
  },
  computed: {
    ...mapState('Auth', ['activeProjectId', 'token']),

    recentIdles() {
      return this.idle;
    },
  },
  watch: {

  },
  methods: {
    init() {
      const dayNames = ['P', 'O', 'T', 'C', 'Pk', 'S', 'Sv'];
      Services.dash.Idle().then(({ data }) => {
        this.combinedWorklogs(data.idle_worklogs).forEach((person) => {
          const diff = 14;
          const days = [];
          for (let i = diff; i >= 0; i--) {
            const d = moment(moment().startOf('day')).subtract(i, 'days');
            days.push({
              weekday: d.isoWeekday(),
              date: d,
              isIdle: person.summedIdleLogs[d.format('YYYY-MM-DD')] > 0,
              idleHours: person.summedIdleLogs[d.format('YYYY-MM-DD')] ? Math.ceil(person.summedIdleLogs[d.format('YYYY-MM-DD')] / 3600) : 0,
              isWeekend: d.isoWeekday() >= 6,
              isToday: moment().isSame(d, 'day'),
              n: dayNames[d.isoWeekday() - 1],
            });
          }

          this.idle.push(
            {
              author: person.author,
              days,
            }
          );
        });
      });
    },

    combinedWorklogs(idleData) {
      const logs = [];
      idleData.forEach((i) => {
        const summedIdleLogs = {};
        i.worklogs.forEach((w) => {
          if (!summedIdleLogs[w.date_started_at]) {
            summedIdleLogs[w.date_started_at] = w.time_spent_seconds;
          } else {
            summedIdleLogs[w.date_started_at] += w.time_spent_seconds;
          }
        });

        logs.push({
          author: i.author,
          summedIdleLogs,
        });
      });
      return logs;
    }
  }
};

</script>

<style lang=scss>
.day-wrapper {
  display: inline-block;

  &.today {
    background: rgba(0, 0, 0, 0.2);
    margin-top: -2em;
    padding-top: 2em;
  }
}

.day-bubble {
  border-radius: 50%;
  display: inline-block;
  border: solid 1px $primary;
  background-color: $white;
  line-height: 1.4em;
  font-size: 0.8em;
  width: 1.6em;
  height: 1.6em;
  text-align: center;
  margin-top: 0.2em;
  margin-right: 0.05em;

  &.idle {
    background-color: $primary;
    color: $white;
    font-weight: bold;
  }

  &.weekend {
    border-color: $red;

    &.idle {
      background-color: lighten($primary, 20%)
    }
  }

  &.today {
    border-color: $green;
  }

}

.user-idle-block .list-group-item {
  border-color: $gray;
  padding-top: 0 !important;
  padding-bottom: 0.1em !important;

}

.user-idle-block {
  min-width: 265px;

  .badge.active-idle-badge {
    vertical-align: top;
  }

  .idle-dates {
    margin-top: -0.6em;
    font-size: 0.8em;
    white-space: nowrap;
  }

  .profile-img {
    max-height: 3.2em;
    border: solid 1px white;
    margin-right: 0.2em;
  }
}
</style>
